export default "__VITE_ASSET__C$X$tcsQ__"